import { FC } from "react";

import { VisibilityOff, Visibility } from "@mui/icons-material"
import { IconButton, InputAdornment, TextField } from "@mui/material"
import { styles } from "./styles"

import MailIcon from '@mui/icons-material/Mail';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';

interface RegisterType {
  username: string;
  setUsername: (username: string) => void;
  password: string;
  setPassword: (password: string) => void;
  showPassword: boolean;
  setShowPassword: (show: boolean) => void;
  email: string;
  setEmail: (email: string) => void;
}

export const Register: FC<RegisterType> = props => {
  const { 
    username,
    setUsername,
    password,
    setPassword,
    showPassword,
    setShowPassword,
    email, 
    setEmail
  } = props;
  
  return(
  <>
    <TextField
      label="Email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      fullWidth
      slotProps={{
        input: {
        startAdornment: (
          <InputAdornment position="start">
            <MailIcon sx={{ color: 'grey.400' }} />
          </InputAdornment>
        ),
        },
      }}
      variant="outlined"
      sx={styles.input}
    />
    <TextField
      label="Username"
      value={username}
      onChange={(e) => setUsername(e.target.value)}
      fullWidth
      slotProps={{
        input: {
        startAdornment: (
          <InputAdornment position="start">
          <PersonIcon sx={{ color: 'grey.400' }} />
          </InputAdornment>
        ),
        },
      }}
      variant="outlined"
      sx={styles.input}
    />
    <TextField
      label="Password"
      type={showPassword ? 'text' : 'password'}
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      fullWidth
      slotProps={{
        input: {
          startAdornment: (
          <InputAdornment position="start">
            <LockIcon sx={{ color: 'grey.400' }} />
          </InputAdornment>
          ),
          endAdornment: (
          <InputAdornment position="end">
            <IconButton
            onClick={() => setShowPassword(!showPassword)}
            edge="end"
            sx={{ color: 'grey.400' }}
            >
            {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
          ),
        }
      }}
      variant="outlined"
      sx={styles.input}
    />
  </>
  )
}